import React,{useState,useEffect,useRef, useContext} from 'react';
import './Home.css';
import { Toaster } from 'react-hot-toast';
import { ModalNuevaCotizacion, ModalRealizarCobro, ModalAutorizarTramite, ModalFinalizarProceso, ModalNotificarCliente, ModalHistorial, ModalTwoColumnsOt } from '../../utils/modals';
import { uniqid } from "../../utils/utils";
import moment from "moment";
import "moment/locale/es";
import { Row,Col,Form, Button } from 'react-bootstrap';
import TablaRecibos from '../TablaRecibos/TablaRecibos';
import { useSelector,useDispatch } from 'react-redux'; 
import { setStateHome, setStateGlobal, showAlert } from '../../reducers/appReducer';
import { RightSidebarNuevaCotizacion, } from '../RightSidebar/RightSidebar';
import { AuthContext } from '../../auth/AuthContext';
import { Navigate, useNavigate } from 'react-router-dom';

moment.locale("mx");

export const Home = ({typeView, socket}) => {

  const { usuario } = useContext(AuthContext);
  const stateGlobal = useSelector( (state) => state.agents );
  const stateHome = stateGlobal.home;
  const dispatch = useDispatch();
  const {
    recibosSearch,
    customDate,
    fechaInicio,
    fechaFin,
  } = stateHome;

  let { 
    dataTramite,
    showSidebarModificarOT,
    showModalVisualizarOT,
  } = stateGlobal;

  const refDateToday = useRef(null);
  const refDateTomorrow = useRef(null);
  const today = moment().add(-1, 'year').format('YYYY-MM-DD');
  const tomorrow = moment(today,'YYYY-MM-DD').add(1, 'year').format('YYYY-MM-DD');

  const [state,setState] = useState({ changeTab: false });
  let [dataModificaInputsOT, setModificaOT] = useState([]);
  const [btnIsLoading, setBtnIsLoading] = useState(false);


  const getItemByArrProcess = (_item, id) => {

    let itemTramite, _tmp = _item
    // Posición 0 en arrOT significa le primer trámite (pensamos en un multitrámites en algún momento)
    const arrProcess = _tmp.arrOT[0].arrProcess

    for(var a in arrProcess) {
      if(arrProcess[a].id === id) {
        itemTramite = arrProcess[a]
      }
    }

    return itemTramite
  }

  const setModalVisualizarOT = (opt) => {
    dispatch( setStateGlobal( { showModalVisualizarOT: opt, } ) );
  }

  const setSidebarModificarOT = (opt) => {
    dispatch( setStateGlobal( { showSidebarModificarOT: opt, } ) );
  }

  const handleSubmitSearch = (e) => {
    e.preventDefault();
    getTramitesByDate();
  }

  const [windowDimenion, detectHW] = useState({
    winWidth: window.innerWidth,
    winHeight: window.innerHeight,
  })

  const detectSize = () => {
    detectHW({
      winWidth: window.innerWidth,
      winHeight: window.innerHeight,
    })
  }
  
  useEffect(() => {
    window.addEventListener('resize', detectSize)
    return () => window.removeEventListener('resize', detectSize)
  }, [windowDimenion])

  useEffect(() => {
    getClientes();
    dispatch(setStateHome( { 
      isLoadPanel: true,
      fechaInicio: today,
      fechaFin: tomorrow,
      customDate: true
    }));
    if(!customDate){
      dispatch( setStateHome( {
        fechaInicio: today, fechaFin: tomorrow,
        arrSections: {
          cotizaciones: true,
          orden_trabajo: true,
          caja: false,
          creditos: false,
          finanzas: false,
          procesos: false,
        }
       } ) )
    }
  },[]);

  useEffect(() => {
    if(stateHome.customDate){
      getTramitesByDate();
    }
  },[stateHome.customDate]);

  const getTramitesByDate = () =>{
    dispatch(setStateHome( { isLoadPanel: true}));
    const data = {
      date_start: refDateToday.current.value,
      date_end: refDateTomorrow.current.value 
    };
    fetch('https://mercedes.wsoft.com.mx/interbrokers/REST/Controller.php?opt=getTramitesByDate',{
      method: 'POST',
      mode:'cors',
      body: JSON.stringify(data),
    })
    .then( response => response.json())
    .then( response => {
      dispatch( setStateGlobal({ dataArray: response.documents, }) )
      dispatch( setStateHome( { isLoadPanel: false}) );
      
    })
  }

  useEffect(() => {
    if(showSidebarModificarOT) {
      setTimeout(() => {
        setModificaOT( JSON.parse( JSON.stringify(dataTramite.arrOT[0].info ) ) )
      }, 100)
    }
  }, [showSidebarModificarOT]);

  const getClientes = () => {
    fetch('https://mercedes.wsoft.com.mx/interbrokers/REST/Controller.php?opt=getClientes',{
      method: 'POST',
      mode:'cors',
    })
    .then( response => response.json())
    .then ( response => {
      const arrSelect = [];
      if(response.documents.length > 0){
        response.documents.map((t,e) => {
          arrSelect.push({
            value: t._id,
            label: t.nombre_completo
          })
        })
      }
      dispatch( setStateHome({ arrClientes: response.documents, arrSelectClientes: arrSelect }) )
    })
  }

  const isPayed = (tramite) => {
    const { arrOT,arrCobranza, cantidad } = tramite;
    let totalAbonos = 0
    arrCobranza.map((t,e) => {
      totalAbonos += parseFloat(t.cantidadRecibida)
    })
    console.log('totalAbonos1: ', (parseFloat(cantidad) - totalAbonos));
    return ( (parseFloat(cantidad) - totalAbonos) <= 0) ? true : false;
  }

  const updateOT = () => {

    let _dataTramite = [], _tmp = dataTramite, canProcess = false

    for(var a in _tmp.arrOT[0].arrProcess) {

      if(_tmp.arrOT[0].arrProcess[a].id === 'orden_trabajo') {
        _dataTramite.push({ ..._tmp.arrOT[0].arrProcess[a], status: 2, })

      } else if(_tmp.arrOT[0].arrProcess[a].id === 'finanzas') {

        const itemCaja = getItemByArrProcess(dataTramite, 'caja'),
        itemFinanzas = getItemByArrProcess(dataTramite, 'finanzas')

        if( isPayed(dataTramite) &&
          itemCaja.status === 2 &&
          itemFinanzas.status === 0/* &&
          dataTramite.metodo_pago==='contado'*/
          ) {
          _dataTramite.push({ ..._tmp.arrOT[0].arrProcess[a], status: 1, })
        } else {
          _dataTramite.push(_tmp.arrOT[0].arrProcess[a])
        }
      } else if(_tmp.arrOT[0].arrProcess[a].id === 'procesos') {
        // canProcess = _tmp.arrOT[0].arrProcess[a - 1].status === 2 ? true : false

        const itemFinanzas = getItemByArrProcess(dataTramite, 'finanzas'),
        itemProcesos = getItemByArrProcess(dataTramite, 'procesos')
        if( isPayed(dataTramite) &&
          itemFinanzas.status === 2 &&
          itemProcesos.status === 0
          ) {
          _dataTramite.push({ ..._tmp.arrOT[0].arrProcess[a], status: 1, })
        } else {
          _dataTramite.push(_tmp.arrOT[0].arrProcess[a])
        }
      } else {
        _dataTramite.push(_tmp.arrOT[0].arrProcess[a])
      }

    }

    const arrHistory = [...dataTramite.arrOT[0].arrHistory, {
      usuario_nombre: usuario.nombre, fecha: moment().format('YYYY-MM-DD HH:mm:ss'), motivo: "Modificó la órden de trabajo", id: 'cotizaciones',
    }]

    const dataUpdate = {
      info: dataModificaInputsOT,
      arrProcess: _dataTramite,
      arrHistory,
      id_tramite_ot: dataTramite.id_cotizacion,
      id_cotizacion: dataTramite.id_cotizacion,
    }

    setBtnIsLoading(true);

    dataModificaInputsOT.map((form) => {
      if(form.tipo=='file' && typeof form.file !== 'undefined') {
        let formData = new FormData();
        formData.append('id', form.value)
        formData.append('files',form.file)

        fetch('https://mercedes.wsoft.com.mx/interbrokers/REST/Controller.php?opt=saveFileTramite',{
          method: 'POST',
          mode: 'cors',
          body: formData,
        }).then( response => response.json())
        .then( response => {

          dispatch(showAlert({
            show : true, 
            message : 'Documento / imagen subida con éxito.',
            type: 'success',
            duration: 3000,
          }))

        })

      }
    })

    // if(formData.has('id')) {
    // } else {
      fetch('https://mercedes.wsoft.com.mx/interbrokers/REST/Controller.php?opt=updateTramitesOt',{
       method: 'POST',
       mode: 'cors',
       body: JSON.stringify(dataUpdate),
      })
      .then( response => response.json())
      .then( response => {
        dispatch( showAlert( {
          show : true, 
          message : 'Orden de trabajo terminada con éxito.',
          type: 'success',
          duration: 3000,
        } ) )
        setSidebarModificarOT(false)
        setBtnIsLoading(false);
        getTramitesByDate();
        // socket.emit("toCajero", { client: 'hgapp', substrace: 'updateCost', })
      })
    // }

    return false
  }

  const searchData = recibosSearch.toLowerCase();
  let filteredData = [];
  let dataArray = stateGlobal.dataArray;

  if (recibosSearch == "") {
    filteredData = dataArray;
  } else {
    filteredData = dataArray.filter((el) => {
      const { nombre, concepto2, created_at } = el;
      return (
        nombre?.toLowerCase().includes(searchData ) ||
        concepto2?.toLowerCase().includes(searchData ) ||
        created_at?.toLowerCase().includes(searchData)
      );
    });
  }

  if(usuario.logged){
    if(usuario.tipo_usuario!=='1' && usuario.tipo_usuario!=='5'){
        return <Navigate to="/login" />
    }
  }

  return (
    <div className="container-fluid">

      <div className="ws-main-container container-fluid">
        {/* Filtros */}
        <div className="ws-tab-container pb-3">
          {/* Tab section */}
          <Row>
            <Col>
              {/* Formulario de búsqueda por rango de fecha */}
              <Form onSubmit={handleSubmitSearch} className="d-flex align-items-end flex-md-row gap-2 ws-main-datebar">
                {(typeView === 'home' && usuario.tipo_usuario === '1' && windowDimenion.winWidth >= windowDimenion.winHeight) && (
                  <>
                    <Button onClick={() => { dispatch( setStateGlobal({ showModalNuevaCotizacion: true, }) ) }} className="ws-btn-blue-2 ws-main-add-cotizacion">Agregar cotización</Button>
                    <Button onClick={()=>window.location.href=`directorio`} className="ws-btn-blue-2 ws-main-add-cotizacion btn btn-primary">
                      <i className="bi bi-person-plus-fill"></i>&nbsp;Agregar nuevo cliente
                    </Button>
                  </>
                  )
                }
                {(typeView === 'home' && usuario.tipo_usuario === '5' && windowDimenion.winWidth >= windowDimenion.winHeight) && (
                  <>
                    <Button onClick={()=>window.location.href=`editartramites`} className="ws-btn-blue-2 ws-main-add-cotizacion btn btn-primary">
                      &nbsp;Modificar costos de trámites
                    </Button>
                  </>
                  )
                }
                <Form.Group className="" style={{float:'right'}}>
                  <Form.Control ref={refDateToday} type="date" defaultValue={fechaInicio} />
                </Form.Group>
                <Form.Group className="" style={{float:'right'}}>
                  <Form.Control ref={refDateTomorrow} type="date" defaultValue={fechaFin} />
                </Form.Group>
                <Form.Group className="" style={{float:'right'}}>
                  <Button type="submit" className="ws-btn-blue-2">&nbsp;&nbsp;<i className="bi bi-search pe-2"></i>{ windowDimenion.winWidth > windowDimenion.winHeight &&( "Buscar") }</Button>
                </Form.Group>
              </Form>
                {(typeView === 'home' && usuario.tipo_usuario === '1' && windowDimenion.winWidth < windowDimenion.winHeight) &&
                  <>
                    <Button onClick={() => { dispatch( setStateGlobal({ showModalNuevaCotizacion: true, }) ) }} className="ws-btn-blue-2 ws-main-add-cotizacion">Agregar cotización</Button>
                    <Button onClick={()=>window.location.href=`directorio`} className="ws-btn-blue-2 ws-main-add-cotizacion btn btn-primary">
                      <i className="bi bi-person-plus-fill"></i>&nbsp;Agregar nuevo cliente
                    </Button>
                  </>
                }
                {(typeView === 'home' && usuario.tipo_usuario === '5' && windowDimenion.winWidth < windowDimenion.winHeight) &&
                  <>
                    <Button onClick={()=>window.location.href=`editartramites`} className="ws-btn-blue-2 ws-main-add-cotizacion btn btn-primary">
                      &nbsp;Modificar costos de trámites
                    </Button>
                  </>
                }
            </Col>
          </Row>
          {/* Formulario de búsqueda por filtro ingresado */}
          <Row className="mt-3">
            <Col xs={12}> 
              <Form onSubmit={ (e) => e.preventDefault() }>
                <Form.Group className="group-search">
                  <i className="bi bi-search pe-2"></i>
                  <Form.Control 
                  type="search"
                  className="ws-input-search"
                  placeholder="Filtrar por nombre, trámite, fecha..."
                  value={recibosSearch}
                  onChange={ (e) => dispatch( setStateHome( { recibosSearch: e.target.value } ) ) }
                  />
                </Form.Group>
              </Form>
            </Col>
          </Row>
        </div>
        {/* TABLA DE LOS RECIBOS */}
        <TablaRecibos 
          state={state} 
          setState={setState}
          filteredData={filteredData} 
          typeView={typeView}
          reloadData={getTramitesByDate}
        />
        {/* Modals */}
        <ModalNuevaCotizacion socket={socket} handleClose={ () => {
          dispatch( setStateGlobal({ showModalNuevaCotizacion: false, }))
        }} />
        <ModalRealizarCobro socket={socket} handleClose={ () => {
          dispatch( setStateGlobal({ showModalRealizarCobro: false, }))
        }} />  
        <ModalAutorizarTramite socket={socket} handleClose={ () => {
          dispatch( setStateGlobal({ showModalAutorizarTramite: false, }))
        }} />  
        <ModalFinalizarProceso socket={socket} handleClose={ () => {
          dispatch( setStateGlobal({ showModalFinalizarProceso: false, }))
        }} />  

        <ModalNotificarCliente socket={socket} handleClose={ () => {
          dispatch( setStateGlobal({ showModalNotificarCliente: false, }))
        }} />  

        <ModalHistorial socket={socket} handleClose={ () => {
          dispatch( setStateGlobal({ showModalHistorial: false, }))
        }} />  

        {/* MODAL OT - TWO COLUMNS */}
        <ModalTwoColumnsOt 
        title="Visualizar orden de trabajo" 
        show={showModalVisualizarOT} 
        socket={socket}
        handleClose={ () => setModalVisualizarOT(false) } 
        typeView={typeView}
        />
        {/* TOAST NOTIFICATION */}
        <Toaster position='top-right' />

        <RightSidebarNuevaCotizacion 
        status={showSidebarModificarOT} 
        setStatus={() => setSidebarModificarOT(true)} 
        title="Modificar orden de trabajo | " 
        onClose={() => { setSidebarModificarOT(false) }} 
        onSave={ () => updateOT() } 
        loading={btnIsLoading}
        >
          <Form>
            <Row className="ws-form-group-divider pb-3 pt-3">
              {
                dataModificaInputsOT.map((t,e) => (
                  <Col key={`list-${e}`} xs={12} lg={12}>
                    <Form.Group className="mb-2">
                      <Form.Label className="ws-form-label">  
                        {t.nombre}
                      </Form.Label>
                      <Form.Control defaultValue={ t.tipo==='file' ? null : dataModificaInputsOT[e].value }  name={t.id} type={t.tipo} multiple={(t.tipo==='file') ? true : false}
                      onChange={ (ev) => {
                        if(t.tipo==='file') {
                          const id = uniqid()
                          dataModificaInputsOT[e].value = id
                          dataModificaInputsOT[e].file = ev.target.files[0]
                        } else {
                          dataModificaInputsOT[e].value = ev.target.value
                        }

                        setModificaOT(dataModificaInputsOT)
                       } }

                      />
                    </Form.Group>
                  </Col>
                ))
              }
              <hr />
            </Row>
          </Form>
        </RightSidebarNuevaCotizacion>

      </div>
    </div>
  )
}







